var _ = require('lodash');
var radio = require("react-pubsub-via-radio.js/radio");
var RadioMixin = require("./RadioMixin");

var SafeRadioBroadcast = _.memoize(function(name){
	return function(){
		var r = radio(name);
		r.broadcast.apply(r.channel(name), arguments);
	};
});

module.exports = {
	RadioAjax: function(name, callback, singletonKeyFn){
		radio(name).subscribe((function(){
			var ajax_waiting = {};
			return function(){
				var onSuccess = SafeRadioBroadcast(name + '_succeeded');
				var onFail = SafeRadioBroadcast(name + '_failed');

				var finishFunctions = [onSuccess, onFail];

				if(_.isFunction(singletonKeyFn)){
					var key = singletonKeyFn.apply(null, arguments);

					radio(name + '_waiting_on_server').broadcast(key);
					if(_.has(ajax_waiting, key) && ajax_waiting[key] === true){
						return;
					}
					ajax_waiting[key] = true;

					finishFunctions = [
						function(){
							onSuccess.apply(null, [key].concat(_.toArray(arguments)));
							ajax_waiting[key] = false;
						},
						function(){
							onFail.apply(null, [key].concat(_.toArray(arguments)));
							ajax_waiting[key] = false;
						}
					];
				}
				callback.apply(null, _.toArray(arguments).concat(finishFunctions));
			};
		}()));
		radio(name + '_failed').subscribe(function(){
			console.error(name, arguments);
		});
	},
	reloadDisplaylists: function(){
		radio('invalidate_Displaylists_cache').broadcast();
		radio('Displaylists_get').broadcast();
	},
	RadioAjaxMixin: function(){
		var actions = _.flattenDeep(_.toArray(arguments));

		return {
			mixins: [RadioMixin],
				getInitialState: function(){
					//must gen a new fromPairs for each instance, otherwise you have shared mutable state
					return _.object(_.map(actions, function(a){
						return [a , {waiting: false, data: null, error_message: null}];
					}));
				},
				__RadioAjax_setActionState: function(action, o, cb){
					var s = {};
					s[action] = _.extend({}, this.state[action], o);
					this.setState(s, cb);
				},
				componentWillMount: function(){
					var self = this;
					var childFunction = function(a, fn_name){
						if(_.isFunction(self["__RadioAjax_" + fn_name + "_" + a])){
							return self["__RadioAjax_" + fn_name + "_" + a];
						}
						return _.noop;
					};
					var isMyKey = function(a, key){
						return key === childFunction(a, "key")();
					};
					self.radio = _.object(_.flatten(_.map(actions, function(a){
						return [
							[a + "_waiting_on_server", function(key){
								if(isMyKey(a, key)){
									self.__RadioAjax_setActionState(a, {waiting: true, data: null, error_message: null});
									childFunction(a, "onWait")();
								}
							}],
							[a + "_succeeded", function(key, data){
								if(isMyKey(a, key)){
									self.__RadioAjax_setActionState(a, {waiting: false, data: data, error_message: null});
									childFunction(a, "onSuccess")(data);
								}
							}],
							[a + "_failed", function(key, message){
								if(isMyKey(a, key)){
									self.__RadioAjax_setActionState(a, {waiting: false, error_message: message});
									childFunction(a, "onFail")(message);
								}
							}]
						];
					})));
				}
		};
	}
};



//////////////////
// WEBPACK FOOTER
// ./~/ES/utils/ServicesUtils.js
// module id = 32
// module chunks = 0 1 2 3 4